import { Text, HelpIndicator, Flex } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";

export interface HeaderRendererParamProps {
  displayName: string;
  value?: string | null;
}

type Props = {
  params: HeaderRendererParamProps;
  tooltipContent?: string;
};

const HeaderCellRenderer = ({ params, tooltipContent }: Props) => {
  return (
    <Flex css={{ width: "100%", alignItems: "center" }} gap={4}>
      <Text marginBottom="xs" variant="strong-md">
        {params.displayName}
      </Text>
      {tooltipContent && (
        <HelpIndicator id={params.displayName} placement="top" content={tooltipContent}>
          <Icon data-testid="helperIndicator" type="question-circle" variant="outline" />
        </HelpIndicator>
      )}
    </Flex>
  );
};

export default HeaderCellRenderer;
